import { TV2M_NOTIFICATION_BODY_SUFFIX, TV2M_NOTIFICATION_TITLES, } from '@apm/contracts';
/**
 * 트리거 소스별 폴백 문구 (TS-02).
 *
 * 문구 표 자체는 `@apm/contracts` 에 있다 — 채우는 것은 서버이고 폴백하는 것은 SDK 라
 * 두 패키지가 같은 값을 봐야 한다 (`tv2m.ts` 의 `TV2M_NOTIFICATION_TITLES` 주석).
 * SDK 는 상품명·가격을 모르므로 본문은 꼬리 문구만 쓴다.
 */
export function fallbackNotificationCopy(triggerType) {
    return {
        title: TV2M_NOTIFICATION_TITLES[triggerType],
        body: TV2M_NOTIFICATION_BODY_SUFFIX,
    };
}
/**
 * payload 의 문구를 쓰되 비어 있으면 폴백한다.
 *
 * **`title` 과 `body` 를 따로 판정한다.** 한쪽만 비는 경우가 실재한다 — 서버가 상품명을
 * 못 읽어 본문만 비는 것이 그렇다. 묶어서 판정하면 멀쩡한 제목까지 버린다.
 *
 * 공백만 있는 문자열도 빈 것으로 본다. 알림에 공백 제목이 뜨면 사용자에게는 그냥
 * **제목이 없는 알림**이고, 그 상태로는 무엇을 눌러야 하는지 알 수 없다.
 */
export function resolveNotificationCopy(payload) {
    const fallback = fallbackNotificationCopy(payload.trigger_type);
    return {
        title: isBlank(payload.title) ? fallback.title : payload.title,
        body: isBlank(payload.body) ? fallback.body : payload.body,
    };
}
function isBlank(value) {
    return value.trim() === '';
}
//# sourceMappingURL=notification-copy.js.map